import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      onPageChange(pageNumber);
    }
  };

  return (
    <div className="pagination p-2">
      {/* <button 
        onClick={() => paginate(currentPage - 1)} 
        disabled={currentPage === 1}
        className="pagination-button"
      >
        Önceki
      </button> */}
      
      {currentPage > 2 && (
        <button
          onClick={() => paginate(1)}
          className="pagination-button"
        >
          1
        </button>
      )}
      
      {currentPage > 3 && (
        <span className="pagination-ellipsis">...</span>
      )}
      
      {currentPage > 1 && (
        <button
          onClick={() => paginate(currentPage - 1)}
          className="pagination-button"
        >
          {currentPage - 1}
        </button>
      )}
      
      <button
        onClick={() => paginate(currentPage)}
        className="pagination-button active"
      >
        {currentPage}
      </button>
      
      {currentPage < totalPages && (
        <button
          onClick={() => paginate(currentPage + 1)}
          className="pagination-button"
        >
          {currentPage + 1}
        </button>
      )}
      
      {currentPage < totalPages - 2 && (
        <span className="pagination-ellipsis">...</span>
      )}
      
      {currentPage < totalPages - 1 && (
        <button
          onClick={() => paginate(totalPages)}
          className="pagination-button"
        >
          {totalPages}
        </button>
      )}
      
      {/* <button 
        onClick={() => paginate(currentPage + 1)} 
        disabled={currentPage === totalPages}
        className="pagination-button"
      >
        Sonraki
      </button> */}
    </div>
  );
};

export default Pagination; 